module.exports = __webpack_public_path__ + "img/hobby_explore.aeb4785a.svg";